/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2231
 */

var r = require(/* 532 */"../532")
module.exports = function (e, t) {
  for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = r(e));) {
    ;
  }
  return e
}
